// @flow

// Vendors
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

// Actions
import { closeModal } from '../../../../reducers/modal/modalActions';

// Components
import { FormActions, FormActionsItem } from '../../Forms/FormActions';
import Trans from '../../Trans/Trans';
import Modal from '../Modal';
import HoverSelectOption from '../../HoverSelectOption/HoverSelectOption';
import { TxButton, TxButtonMode } from 'texkit-ui/components';

// Styles
import './check-email-access-modal.scss';

const CheckEmailAccessModal = () => {
  const dispatch = useDispatch();
  const modal = useSelector(state => state.modal || {});
  const maskedEmail = modal?.data?.maskedEmail;

  function handleNoAccess() {
    dispatch(
      closeModal('CheckEmailAccessModal', {
        onClose: () => dispatch(push('/account-recovery/success')),
      })
    );
  }

  function handleSignIn() {
    dispatch(closeModal('CheckEmailAccessModal'));
    dispatch(push('/'));
  }

  function handleResetPassword() {
    dispatch(closeModal('CheckEmailAccessModal'));
    dispatch(push('/forgot-password'));
  }

  return (
    <Modal
      id="CheckEmailAccessModal"
      className="check-email-access-modal"
      disableOnClickOutside
      disableCloseButton={false}
    >
      <h2 className="modal-title">
        <Trans
          file="AccountRecovery"
          id="CheckEmailAccessTitle"
          fallback="If you can access this email, you don’t need to deactivate your account"
        />
      </h2>
      <div className="modal-content">
        {maskedEmail && (
          <p className="check-email-access-modal__email">{maskedEmail}</p>
        )}
        <p>
          <Trans
            file="AccountRecovery"
            id="CheckEmailAccessDescription"
            fallback="The email address above is your TxT username (shown partially masked for security). Here's how you can use this email to get back into TxT faster:"
          />
        </p>
        <div className="check-email-access-modal__options">
          <HoverSelectOption
            label={
              <Trans
                file="AccountRecovery"
                id="CheckEmailAccessSignInLabel"
                fallback="Sign in with this email"
              />
            }
            description={
              <Trans
                file="AccountRecovery"
                id="CheckEmailAccessSignInDescription"
                fallback="On the sign in page, enter the full version of the email above and your password."
              />
            }
            onClick={handleSignIn}
          />
          <HoverSelectOption
            label={
              <Trans
                file="AccountRecovery"
                id="CheckEmailAccessResetPasswordLabel"
                fallback="Reset your password with this email"
              />
            }
            description={
              <Trans
                file="AccountRecovery"
                id="CheckEmailAccessResetPasswordDescription"
                fallback="You can use the full version of the email above to change it."
              />
            }
            onClick={handleResetPassword}
          />
        </div>
        <FormActions align="center">
          <FormActionsItem>
            <TxButton
              type="button"
              mode={TxButtonMode.Secondary}
              onClick={handleNoAccess}
            >
              <Trans
                file="AccountRecovery"
                id="CheckEmailAccessNoAccessButton"
                fallback="I can't access this email"
              />
            </TxButton>
          </FormActionsItem>
        </FormActions>
      </div>
    </Modal>
  );
};

export default CheckEmailAccessModal;
